import React from "react";
import PlatformNewsActionLink from "./PlatformNewsActionLink";

export default function PlatformNewsCallout({callout}) {
    if (!callout) {
        return null;
    }

    return (
        <section className="platform-news-article__offer">
            {callout.label && (
                <span className="platform-news-article__offer-label">
                    {callout.label}
                </span>
            )}

            <h3>{callout.title}</h3>

            {callout.price && (
                <div className="platform-news-article__price">
                    <span>{callout.price.previous}</span>
                    <strong>{callout.price.current}</strong>
                    <small>{callout.price.note}</small>
                </div>
            )}

            {callout.description && (
                <p>{callout.description}</p>
            )}

            <PlatformNewsActionLink
                action={callout.action}
                className="platform-news-article__action"
            />
        </section>
    );
}
